/** 活动券状态 CouponState 和 ExchangeState 的整合  */
export var ActivityCouponState;
(function (ActivityCouponState) {
    /** 未领取 */
    ActivityCouponState["notReceived"] = "notReceived";
    /** 已领取 */
    ActivityCouponState["received"] = "received";
    /** 已使用 */
    ActivityCouponState["used"] = "used";
    /** 已过期 */
    ActivityCouponState["expired"] = "expired";
    /** 未开始 */
    ActivityCouponState["notStarted"] = "notStarted";
    /** 可兑换，展示库存 */
    ActivityCouponState["avaliable"] = "avaliable";
    /** 奖品维度-今日已领完 */
    ActivityCouponState["dayLimit"] = "dayLimit";
    /** 奖品维度-券已售罄 */
    ActivityCouponState["totalLimit"] = "totalLimit";
    /** 用户维度-月限额 */
    ActivityCouponState["monthUserLimit"] = "monthUserLimit";
    /** 用户维度-总限额 */
    ActivityCouponState["totalUserLmit"] = "totalUserLmit";
    /** 印花不足 */
    ActivityCouponState["qualNoEnough"] = "qualNoEnough";
})(ActivityCouponState || (ActivityCouponState = {}));
